import type { CSSProperties } from 'react'
import {
  DEFAULT_DESCRIPTION_Y,
  DEFAULT_SUPPORT_HOURS_Y,
  DEFAULT_BONUS_Y,
  DEFAULT_LOYALTY_Y,
  DEFAULT_NEGOTIATION_Y,
  DEFAULT_PAYMENT_Y,
  DEFAULT_PRICE_Y,
  DEFAULT_PROJECT_TYPE_Y,
  DEFAULT_TITLE_Y,
} from '@/utils/dealCalculations'

export const SLIDE_GREEN_DARK = '#070713'
export const SLIDE_GREEN_ACCENT = '#ff2f86'
export const SLIDE_GRAY_LIGHT = '#0d1020'

export const SLIDE_LAYOUT_FALLBACK = {
  titleY: DEFAULT_TITLE_Y,
  projectTypeY: DEFAULT_PROJECT_TYPE_Y,
  descriptionY: DEFAULT_DESCRIPTION_Y,
  supportHoursY: DEFAULT_SUPPORT_HOURS_Y,
  bonusY: DEFAULT_BONUS_Y,
  priceY: DEFAULT_PRICE_Y,
  paymentY: DEFAULT_PAYMENT_Y,
  loyaltyY: DEFAULT_LOYALTY_Y,
  negotiationY: DEFAULT_NEGOTIATION_Y,
} as const

/** Mantém o Enter do campo e tira espaço sobrando em cada linha. */
export function formatSlideDescriptionBody(text: string): string {
  return text
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .split('\n')
    .map((line) => line.replace(/[ \t]+/g, ' ').trim())
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}

/** Bloco 6 — valor principal (preview 16:9). */
export const SLIDE_PRICE_MAIN_STYLE: CSSProperties = {
  color: SLIDE_GREEN_ACCENT,
  fontSize: 'clamp(8px, 2.5cqw, 24px)',
  fontWeight: 700,
  fontFamily: 'Arial, sans-serif',
}

export const SLIDE_PRICE_COMPARE_STYLE: CSSProperties = {
  color: '#a78bfa',
  fontSize: 'clamp(6px, 1.75cqw, 14px)',
  fontWeight: 600,
  fontFamily: 'Arial, sans-serif',
  textDecoration: 'line-through',
}

export const SLIDE_DESCRIPTION_TEXT_STYLE: CSSProperties = {
  color: '#d7d9e8',
  fontSize: 'clamp(4px, 1.2cqw, 11px)',
  fontWeight: 600,
  fontFamily: 'Arial, sans-serif',
  lineHeight: 1.22,
  margin: 0,
  padding: 0,
  display: 'block',
  whiteSpace: 'pre-line',
  wordBreak: 'break-word',
}

/** Bloco 5 — informativo de horas de suporte (abaixo da descrição). */
export const SLIDE_SUPPORT_HOURS_TEXT_STYLE: CSSProperties = {
  color: SLIDE_GREEN_ACCENT,
  fontSize: 'clamp(6px, 1.25cqw, 12px)',
  fontWeight: 700,
  fontFamily: 'Arial, sans-serif',
  lineHeight: 1.25,
  margin: 0,
  padding: 0,
  display: 'block',
  whiteSpace: 'normal',
  wordBreak: 'break-word',
}

/** Faixas múltiplas de horas/preço no bloco verde. */
export const SLIDE_SUPPORT_TIER_LINE_STYLE: CSSProperties = {
  color: '#FFFFFF',
  fontSize: 'clamp(5px, 1.05cqw, 10px)',
  fontWeight: 600,
  fontFamily: 'Arial, sans-serif',
  lineHeight: 1.35,
  margin: 0,
  padding: 0,
  display: 'block',
  whiteSpace: 'normal',
  wordBreak: 'break-word',
}
